import React, { useEffect, useRef, useState } from 'react'
import colors from '../../../Utils/colors';
import { TextField } from '@mui/material';
import ToggleButtons from './ToggleButton';
import images from '../../../Utils/images';
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

const CFDescription = ({ descriptionProps, updateDescriptionProps}) => {

    const fonts = [
        'Segoe UI',
        'Arial',
        'Courier New',
        'Georgia',
        'Times New Roman',
        'Verdana',
        'Roboto',
        'Open Sans',
        'Lato',
    ];

    const fontWeight = [
        'Light',
        'Regular',
        'Bold'
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("dsfsdfsdf ",name,value)
        updateDescriptionProps({ [name]: value });
    };

  return (
    <>
    <div className='d-flex flex-column justify-content-start align-items-center w-100' style={{
        backgroundColor:colors.white01,
        borderRadius:12,
        border:`1px solid ${colors.borderwhite}`,
        paddingInline:20,
        paddingBlock:16,
        marginBlock:8,
    }}>
        <div className='d-flex flex-row justify-content-between align-items-center w-100'>
            <h4 className='mb-2' style={{
                fontSize: 18,
                fontWeight:700,
            }}>
                {'Description'}
            </h4>
            <ToggleButtons 
                alignment={descriptionProps.alignment}
                handleChange={(value)=>{
                    const name = 'alignment'
                    console.log("dsfsdfsdf ",name,value)
                    updateDescriptionProps({ [name]: value });
                }}
            />
        </div>
        <div className='d-flex flex-column justify-content-stretch align-items-center w-100 h-auto'>
            <TextField 
                name="description"
                placeholder='Enter form description here'
                value={descriptionProps.description}
                onChange={handleChange}
                type='text'
                size='small'
                style={{marginBlock:8,width:'100%'}}
                className='btncustom'
            />
        </div>
        <div className='d-flex flex-row justify-content-between align-items-cneter w-100 my-2'>
            <div className='d-flex flex-column justify-content-stretch align-items-start px-2 py-2' style={{flex:1}}>
                <p style={{fontWeight:500}}>
                    {'Font'}
                </p>
                <Select
                    name='font'
                    value={descriptionProps.font}
                    onChange={handleChange}
                    style={{marginBlock:8,width:'100%'}}
                    size='small'
                >
                    {fonts.map((font) => (
                        <MenuItem key={font} value={font}>
                            {font}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <div className='d-flex flex-column justify-content-stretch align-items-start px-2 py-2' style={{flex:1}}>
                <p style={{fontWeight:500}}>
                    {'Font Size (in px)'}
                </p>
                <TextField 
                    name="fontSize"
                    value={descriptionProps.fontSize}
                    // onChange={handleChange}
                    onChange={(e)=>{
                        const value = e.target.value;
                        if (value === '' || /^[0-9\b]+$/.test(value)) {
                            handleChange(e);
                        }
                    }}
                    onBlur={(e)=>{
                        const { value } = e.target;
                        if (value !== '') {
                            const limitedValue = Math.max(12, Math.min(18, Number(value)));
                            updateDescriptionProps({["fontSize"]:limitedValue})
                        }
                    }}
                    type='number'
                    size='small'
                    style={{marginBlock:8,width:'100%'}}
                    className='btncustom' 
                    inputProps={{min:12, max:18}}
                />
            </div>
            <div className='d-flex flex-column justify-content-stretch align-items-start px-2 py-2' style={{flex:1}}>
                <p style={{fontWeight:500}}>
                    {'Font Weight'}
                </p>
                <Select
                    name='fontWeigth'
                    value={descriptionProps.fontWeigth}
                    onChange={handleChange}
                    style={{marginBlock:8,width:'100%'}}
                    size='small'
                >
                    {fontWeight.map((fontweight) => (
                        <MenuItem key={fontweight} value={fontweight}>
                            {fontweight}
                        </MenuItem>
                    ))}
                </Select>
            </div>
        </div>
    </div>
    </>
  )
}

export default CFDescription